import React, { useEffect, useState } from 'react'
import { ReactComponent as BuyClose } from '../../../assets/icons/main/buy-close.svg'
import { ReactComponent as BuyPlus } from '../../../assets/icons/main/buy-order-plus.svg'
import { ReactComponent as CloseIcon } from "../../../assets/icons/portfolio/login-cross.svg";
import Inputs from '../../../components/inputs/Inputs'
import BuyInput from '../../../components/inputs/BuyInput'
import Button from '../../../components/button/Button'
import './BuyOrder.css'
import axios from "axios";
import {enqueueSnackbar, closeSnackbar} from "notistack";
import {Link, useNavigate} from "react-router-dom";
import {roundFractional} from "../../../features/numberRounding";
import {useTranslation} from "react-i18next";

const BuyOrder = ({balance, balanceStatus, stateActive, setStateActive, AVGdata, coinFrom, coinTo, orderType, setOrderType}) => {
    // const [ activeBlock, setActivBlock ] = useState(false)
    const navigate = useNavigate()
    const {t} = useTranslation();
    const token = localStorage.getItem("token")
    const [ menuSelection, setMenuSelection ] = useState(1);
    const [ limitMarket, setLimitMarket ] = useState(1)

    const [ tp, setTP ] = useState(0)
    const [ sl, setSL ] = useState(0)

    const [ price, setPrice ] = useState("")
    const [ count, setCount ] = useState(0)
    const [ leverage, setLeverage ] = useState("3")
    const [ percent, setPercent ] = useState("")
    const [ volume, setVolume ] = useState(0)

    const [avgBalance, setAvgBalance] = useState()
    const [acessOrder, setAcessOrder] = useState(true)

    const action = snackbarId => (
        <button className="close-button" onClick={() => { closeSnackbar(snackbarId) }}>
            <CloseIcon/>
            {/* CLOSEICON */}
        </button>
    );

    const getBalance = () => {
        axios.get(`https://api-ru.fynex.cc/api/api/users/balance/common`, {headers: {"Authorization" : `Bearer ${token}`}})
        .then(res => {
            console.log(res.data, "BALANCE");
            setAvgBalance(res.data)
        })
    }
    const getAcessStatusOrder = () => {
        axios.get(`https://api-ru.fynex.cc/api/api/users/me`, {headers: {"Authorization" : `Bearer ${token}`}})
            .then(res => {
                setAcessOrder(res.data.orders_allowed)
            })
    }

    useEffect(()=>{
        getBalance()
        getAcessStatusOrder()
    },[])

    const checkErrorRate = async (coin_to, coin_from, price) => {
        try {
            const res = await axios.get(`https://api-ru.fynex.cc/rates/rate?ticker=${coin_to}&coin=${coin_from}`);
            const actualPrice = parseFloat(res.data); // Актуальная цена с API
            const orderPrice = parseFloat(price); // Цена на момент покупки
            console.log(`Актуальная цена: ${actualPrice}, Цена ордера: ${orderPrice}`);
    
            // Проверяем, чтобы цены были валидными числами
            if (isNaN(actualPrice) || isNaN(orderPrice) || orderPrice <= 0) {
                console.error("Ошибка: Некорректные данные о цене.");
                return false;
            }
    
            // Вычисляем процентное отклонение
            const percentDiff = Math.abs((actualPrice - orderPrice) / actualPrice) * 100;
            console.log(`Отклонение в цене: ${percentDiff.toFixed(2)}%`);
    
            // Если разница больше 10%, отклоняем ордер
            if (percentDiff > 10) {
                console.log("Разница в цене слишком велика. Ордер отклонён.");
                return false;
            }
    
            return true; // Если всё нормально, разрешаем ордер
        } catch (error) {
            console.error("Ошибка при запросе checkErrorRate:", error);
            return false; // В случае ошибки запрещаем ордер
        }
    };
    

    const handleSubmit = async (event) => {
        if(acessOrder == false){
            enqueueSnackbar(t("BAN.openOrder"), {action, autoHideDuration: 10000, variant: 'error', className: "snackerror"});
        }
        else if(!count || !volume){
            enqueueSnackbar(t("buyOrder.errIncorrectData"), {action, autoHideDuration: 3000, variant: 'error', className: "snackerror"});
        }else if(avgBalance < volume || !avgBalance){
            // alert("Недостаточно средств")
            enqueueSnackbar(t("buyOrder.errNoHaveMoney"), {action, autoHideDuration: 3000, variant: 'error', className: "snackerror"});
        }
        else if (!(await checkErrorRate(coinTo, coinFrom, limitMarket === 2 ? price : AVGdata.lastPrice))) { // Дожидаемся ответа от API
            enqueueSnackbar(t("buyOrder.errReloadPage"), {autoHideDuration: 3000, variant: 'error', className: "error"});
        } 
        else{

                // event.preventDefault();
                setPrice(price == "" ? 0 : price)
                const data = {
                    margin: AVGdata.lastPrice * count,
                    total: volume,
                    price: limitMarket === 2 ? price : AVGdata.lastPrice,
                    amount: count,
                    action: orderType === 1 ? 'buy' : 'sell',
                    coin_to: coinTo,
                    coin_from: coinFrom,
                    leverage: Number(leverage),
                    take_profit: tp == "" ? 0 : tp,  // Здесь подставьте значение тейк-профита, если оно есть
                    stop_loss: sl == "" ? 0 : sl,  // Здесь подставьте значение стоп-лосс, если оно есть
                    short_long: orderType === 1,
                    is_limited: limitMarket === 2,
                    limit: Number(limitMarket === 2 ? price : 0)
                };

            try {
                
                console.log(price, "limitMarket === 2 ? price : AVGdata.lastPrice", limitMarket === 2, limitMarket === 2 ? price : AVGdata.lastPrice, "AVGdata.lastPriceNUM:", Number(AVGdata.lastPrice) );
                console.log(price, "price");
                console.log(count, "count");
                console.log(volume, "volume");
                // console.log(AVGdata, "AVGdata");
                console.log(data, "DATA");
                const res = await axios.post("https://api-ru.fynex.cc/orders/api/order", data, {
                    headers: {"Authorization": `Bearer ${token}`}
                });
                // console.log(res);
                
                setPrice("");
                setCount("");
                // setLeverage("");
                setPercent("");
                setVolume("");
                
                enqueueSnackbar(t("buyOrder.orderCreate"), {autoHideDuration: 3000, variant: 'success', className: "snacksuccess"});
                // reloadUserData()
                
                // КОСТЫЛЬ(!!!!)
                // document.location.reload();
            } catch (error) {
                if(Array.isArray(error.response.data)){
                    console.log(error);
                    error.response.data.detail.forEach(errormsg => {
                        console.log(errormsg.msg);
                        enqueueSnackbar(`${t("buyOrder.errArose")}: ${errormsg.msg}`, {autoHideDuration: 3000, variant: 'error', className: "snackerror"});
                    });
                }else{
                    console.log(error.response.data, "ERROR");
                    
                    enqueueSnackbar(`${t("buyOrder.errArose")}: ${error.response.data.detail.error}`, {autoHideDuration: 3000, variant: 'error', className: "snackerror"});
                }

            }
        }
    };


if (!Math.floor10) {
  Math.floor10 = function (value, exp = 0, precision = 6) {
    if (!Number.isFinite(value)) return value;

    const factor = 10 ** exp;
    const floored = Math.floor(value / factor) * factor;

    // const p = 10 ** precision;
    const p = 10 ** 6;
    return Math.floor(floored * p) / p;
  };
}


    const priceHandler = (num) => {
        setPrice(num);
        setVolume(Math.floor10(count * num, -6))
    };
    const amountHandler = (num) => {
        if(AVGdata.length != 0){
        
            if (limitMarket === 1) {
                setCount(num);
                setVolume(Math.floor10(num * AVGdata.lastPrice, -6))
                console.log(count, "count");
                console.log(volume, "volume");
                
            }
            else {
                setCount(num);
                setVolume(Math.floor10(num * Number(price == "" ? 1 : price), -6))
            }
        }
    };
    const totalHandler = (num) => {
        if(AVGdata.length != 0){
            setVolume(num);
            setCount(Math.floor10(num / AVGdata.lastPrice , -6));
        }
        
    };


    // useEffect(() => {
    //     alert(AVGdata.lastPrice)
    //     if (limitMarket === 1) {
    //         const calculatedVolume = (price / AVGdata.lastPrice) * count;
    //         setVolume(calculatedVolume ? calculatedVolume.toFixed(2) : "");
    //     } else {
    //         const calculatedVolume = price * count;
    //         setVolume(calculatedVolume ? calculatedVolume.toFixed(2) : "");
    //     }
    // }, [price, count, AVGdata.lastPrice, limitMarket]);

    // useEffect(() => {
    //     if (limitMarket === 1) {
    //         const calculatedCount = (volume * AVGdata.lastPrice) / price;
    //         setCount(calculatedCount ? calculatedCount.toFixed(2) : "");
    //     } else {
    //         const calculatedCount = volume / price;
    //         setCount(calculatedCount ? calculatedCount.toFixed(2) : "");
    //     }
    // }, [volume, price, AVGdata.lastPrice, limitMarket]);

    return (
        <div className={stateActive == true ? "BuyOrder BuyOrderActive" : "BuyOrder"}>
        <div className="headline">
            <h3>{t("buyOrder.placeOrder")}</h3>
            <BuyClose onClick={() => setStateActive(false)}/>
        </div>
        <div className="buy-menu">
            {/*<span onClick={()=>setMenuSelection(1)}>*/}
            {/*    <h4 className={menuSelection === 1 ? "span-active" : ""}>Спот</h4>*/}
            {/*    <div className={menuSelection === 1 ? "line line-activ" : "line"}></div>*/}
            {/*</span>*/}
            <span onClick={()=>setMenuSelection(2)}>
                <h4 className={menuSelection === 2 ? "span-active" : ""}>{t("buyOrder.futures")}</h4>
                <div className={menuSelection === 2 ? "line line-activ" : "line"}></div>
            </span>
        </div>

        <div className={menuSelection === 2 ? "orderWrapper orderWrapperFutures" : "orderWrapper"}>
        
            <div className="Futures">
                <div className="slideButtons-wrapper">
                        <div className="slideButtons">
                            <p className={orderType === 1 ? "active" : ""} onClick={()=>setOrderType(1)}>{t("buyOrder.short")}</p>
                            <p className={orderType === 2 ? "active" : ""} onClick={()=>setOrderType(2)}>{t("buyOrder.long")}</p>
                            <div className={orderType=== 2 ? "dynamicSldier activeSldier" : "dynamicSldier"}></div>
                        </div>
                    </div>

                    <div className="limitMarket">
                        <p className={limitMarket == 1 ? "active" : ""} onClick={()=>setLimitMarket(1)}>{t("buyOrder.market")}</p>
                        <p className={limitMarket == 2 ? "active" : ""} onClick={()=>setLimitMarket(2)}>{t("buyOrder.limit")}</p>
                    </div>

                    <div className="available">
                        <h4>{t("buyOrder.available")}</h4>
                        <div className="usdt" onClick={()=>navigate("/account/deposit-crypto")}>{roundFractional(Number(balance))} {coinFrom} <BuyPlus/></div>
                    </div>

                    <Inputs className={limitMarket === 2 && "limitInupts"}>
                        { limitMarket === 2 ? <BuyInput placeholder={t("buyOrder.entryPrice")} textData={coinFrom} valueInput={price} setInputChange={priceHandler}/> : ""}
                        <BuyInput placeholder={t("buyOrder.volume")} textData={coinFrom} valueInput={volume} setInputChange={totalHandler} statusChange={balanceStatus} />
                        <div className="buttons">
                            <div className={leverage == "3" ? "countPercent precentActive" : "countPercent"} onClick={()=>setLeverage("3")}>3x</div>
                            <div className={leverage == "5" ? "countPercent precentActive" : "countPercent"} onClick={()=>setLeverage("5")}>5x</div>
                            <div className={leverage == "10" ? "countPercent precentActive" : "countPercent"} onClick={()=>setLeverage("10")}>10x</div>
                            <div className={leverage == "20" ? "countPercent precentActive" : "countPercent"} onClick={()=>setLeverage("20")}>20x</div>
                        </div>
                        <BuyInput placeholder={t("buyOrder.count")} textData={coinTo} valueInput={count} setInputChange={amountHandler}/>
                    </Inputs>
                    <Inputs className="futuresInputs">
                        <BuyInput placeholder={t("buyOrder.takeProfit")} textData={coinFrom} valueInput={tp} setInputChange={setTP}/>
                        <BuyInput placeholder={t("buyOrder.stopLoss")} textData={coinFrom} valueInput={sl} setInputChange={setSL}/>

                    </Inputs>

                    <Button onClick={handleSubmit} text={t("buyOrder.confirmOrder")} classname={limitMarket === 2 && "limitButton"}/>
                </div>
            </div>
    </div>
  )
}

export default BuyOrder